export class  DataStatus {
    private status: 'info' | 'failure' | 'success';
    private alertErrorClasses: string[];
    private alertInfoClasses: string[];

    public errorMessage: string;
    public infoMessage: string;

    setStatus(status: 'info' | 'failure' | 'success') {
        this.status = status;
        return this;
    }
    setAlertMessage(message: string) {
        switch (this.status) {
            case 'info':
                this.infoMessage = message;
                return this;
            case 'failure':
                this.errorMessage = message;
                return this;
            default:
                return this;
        }
    }
    setAlertClasses(alertCSS: string[]) {
        switch (this.status) {
            case 'info':
                this.alertInfoClasses = alertCSS;
                return this;
            case 'failure':
                this.alertErrorClasses = alertCSS;
                return this;
            default:
                return this;
        }
    }

    resetStatus() {
        this.status = null;
    }

    isSuccesfully = () => this.status === 'success';
    thereIsInfo = () => this.status === 'info';
    isFailed = () => this.status === 'failure';
    isNullOrUndefined = () => this.status === null || this.status === undefined;

    getInfoMessage = () => this.infoMessage;
    getErrorMessage = () => this.errorMessage;

    public errorCSS = () => this.alertErrorClasses;
    public infoCSS = () => this.alertInfoClasses;
}
